import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, User } from 'lucide-react';

// Front page (owner, 2026-10-27): choose the personal or the company Power of Attorney.
// Same header and footer as the POA page; buttons styled as the CIPC site's orange buttons.
const LOGO_URL = '/images/TCA_Logo.png';
const BANNER_URL = '/images/TCA_Banner.png';
const TCA_SHORT_LOGO = '/images/TCA_Short_Logo.png';

const CHOICES = [
  { to: '/personal', label: 'Power of Attorney: Personal Taxes', icon: User, testId: 'button-personal' },
  { to: '/company', label: 'Power of Attorney: Company', icon: Building2, testId: 'button-company' },
];

const ChoicePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <main className="flex-1 flex flex-col items-center px-4 pt-[2px] pb-6 sm:pb-8 bg-white">
        <div className="mb-4 sm:mb-6 flex flex-col items-center gap-3">
          <img src={LOGO_URL} alt="TCA Auditors Logo" className="h-16 sm:h-20 w-auto object-contain" />
          <img src={BANNER_URL} alt="Tax & Auditing Consultants" className="h-10 sm:h-14 w-auto object-contain" />
        </div>

        <div className="mb-6 pb-2">
          <h1 className="text-xl sm:text-2xl font-extrabold text-tca-blue text-center tracking-wide inline-block underline-tca-blue">
            SARS POWER OF ATTORNEY
          </h1>
        </div>

        <p className="text-gray-700 text-center mb-10">Please choose the Power of Attorney you would like to sign.</p>

        <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 items-stretch">
          {CHOICES.map(({ to, label, icon: Icon, testId }) => (
            <button
              key={to}
              type="button"
              onClick={() => navigate(to)}
              data-testid={testId}
              className="btn-cipc-orange inline-flex items-center justify-center gap-3 font-semibold py-4 px-8 min-h-[64px] text-base sm:text-lg rounded-lg shadow-soft leading-tight"
            >
              <Icon className="w-6 h-6" />
              <span>{label}</span>
            </button>
          ))}
        </div>
      </main>

      <div className="relative">
        <footer className="py-6 px-4">
          <div className="flex flex-col items-center gap-2">
            <div className="text-base font-medium tracking-wide text-muted-foreground">SARS Power of Attorney</div>
          </div>
        </footer>
        <img src={TCA_SHORT_LOGO} alt="TCA Logo" className="absolute bottom-2 right-56 h-12 w-auto object-contain opacity-80" />
      </div>
    </div>
  );
};

export default ChoicePage;
